import brgI18n from '@/locales';
import { workerSalaryType } from '@/constants/worker/workerSalaryType';
const i18n = brgI18n.global;
const lc = 'views.worker_management.';
const salaryTypeCode = [
    workerSalaryType.FIXED_PAY,
    workerSalaryType.PERFORMANCE_PAY,
];
const result = {};
salaryTypeCode.forEach((code, index) => {
    result[code] = {
        text: i18n.t(`${lc}salary_type_code_text[${index}]`),
        value: code,
    };
});
export default result;
